import script from "./MessageCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageCenter.vue?vue&type=script&setup=true&lang=js"

import "./MessageCenter.vue?vue&type=style&index=0&id=5accc940&lang=scss&scoped=true"
import "./MessageCenter.vue?vue&type=style&index=1&id=5accc940&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5accc940"]])

export default __exports__